/**
 * Geode Voice (UPT-2000 lot V0 §5.3) — zone de saisie du simulateur : elle remplace le micro pendant une
 * session simulée, dans le panneau (Module Studio) comme dans le tiroir du copilote. Revue CORE 11.10 : le
 * tiroir n'en avait pas, une session simulée lancée depuis son micro restait muette hors de Module Studio.
 */
import { useId, useState } from 'react';
import { useIntl } from '@/react-intl';
import { getVoiceSession, isMockVoiceSession } from './voiceSessionHolder';
import { useVoiceStore } from './voiceStore';

export type VoiceMockInputProps = {
  /** Classes de la rangée (ex. marge réservée au bouton flottant du copilote dans le panneau). */
  className?: string;
};

export function VoiceMockInput({ className = '' }: VoiceMockInputProps) {
  const intl = useIntl();
  const t = (id: string) => intl.formatMessage({ id });
  const inputId = useId();
  const mockActive = useVoiceStore((store) => store.mockActive);
  const state = useVoiceStore((store) => store.state);
  const [phrase, setPhrase] = useState('');

  // Pas une liste vide : hors session simulée, la saisie n'a pas lieu d'être. // i18n-exempt: not a user-facing empty state
  if (!mockActive || state === 'idle') {
    return null;
  }

  const submit = () => {
    const session = getVoiceSession();
    if (isMockVoiceSession(session) && phrase.trim()) {
      void session.submitPhrase(phrase.trim());
      setPhrase('');
    }
  };

  return (
    <div className={`flex gap-1 ${className}`}>
      <label className="sr-only" htmlFor={inputId}>
        {t('voice.mock.inputLabel')}
      </label>
      <input
        id={inputId}
        value={phrase}
        onChange={(event) => setPhrase(event.target.value)}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            submit();
          }
        }}
        placeholder={t('voice.mock.inputPlaceholder')}
        className="min-w-0 flex-1 rounded-md border border-portal-border bg-portal-surface px-2 py-2 text-sm text-portal-ink"
      />
      <button
        type="button"
        onClick={submit}
        disabled={!phrase.trim()}
        className="rounded-md bg-portal-accent px-3 py-2 text-sm font-semibold text-portal-ink-on-accent disabled:opacity-50"
      >
        {t('voice.mock.send')}
      </button>
    </div>
  );
}

export default VoiceMockInput;
